'use es6';

import { Fragment } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { propertyCanHaveGlobalDefaultValue, i18nKey } from '../../../utils/properties';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Fallback({
  currentOption,
  isGlobalFallback,
  setIsGlobalFallback,
  fallback,
  setFallback,
  settingsLink,
  tooltipClassName
}) {
  const handleGlobalFallbackChange = ({
    target: {
      checked
    }
  }) => {
    setIsGlobalFallback(checked);
    if (checked) {
      setFallback('');
    }
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      className: "m-top-0",
      label: I18n.text(i18nKey('fallbackLabel')),
      tooltip: I18n.text(i18nKey('fallbackHelp')),
      tooltipPlacement: "top right",
      tooltipProps: {
        innerClassName: tooltipClassName
      },
      children: /*#__PURE__*/_jsx(UITextInput, {
        "data-test-id": "local-fallback-input",
        value: fallback,
        disabled: isGlobalFallback === true,
        onChange: ({
          target: {
            value
          }
        }) => setFallback(value)
      })
    }), propertyCanHaveGlobalDefaultValue(currentOption) && /*#__PURE__*/_jsx(UICheckbox, {
      className: "m-top-2",
      size: "small",
      checked: isGlobalFallback,
      onChange: handleGlobalFallbackChange,
      "data-test-id": "default-value-global-checkbox",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        options: {
          href: settingsLink
        },
        message: i18nKey('globalFallbackLabelHelp')
      })
    })]
  });
}
Fallback.propTypes = {
  setFallback: PropTypes.func.isRequired,
  setIsGlobalFallback: PropTypes.func.isRequired,
  settingsLink: PropTypes.string.isRequired,
  currentOption: PropTypes.object,
  isGlobalFallback: PropTypes.bool,
  fallback: PropTypes.string,
  tooltipClassName: PropTypes.string
};